"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const CardImage = ({ isEmpty, children }) => {
    return (react_1.default.createElement("div", { className: `${!isEmpty ? 'CardImage' : 'EmptyCard'}` }, !isEmpty && react_1.default.createElement("div", { className: "bg-dark" }, children)));
};
exports.default = CardImage;
